<template>
  <div>
    <v-layout
      v-if="submission.canEdit || fromDashboard"
      row wrap
      text-xs-center
      text-sm-right
      class="action-button-container">
      <v-flex xs12>
        <!--edit button-->
        <v-btn
          class="action-button"
          :class="{'mobile': isMobile, 'margin-zero': marginZero}"
          fab
          dark
          color="secondary"
          @click="editForm">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <!--duplicate button-->
        <v-btn
          class="action-button"
          :class="{'mobile': isMobile, 'margin-zero': marginZero}"
          fab
          dark
          color="secondary"
          @click="copyForm">
          <v-icon>mdi-content-copy</v-icon>
        </v-btn>
        <!--delete button-->
        <v-btn
          class="action-button"
          :class="{'mobile': isMobile, 'margin-zero': marginZero}"
          fab
          dark
          color="error"
          @click="deleteForm">
          <v-icon>mdi-delete-outline</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <full-screen-loading-spinner v-if="showLoading"></full-screen-loading-spinner>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import api from '@/utils/api';
import FullScreenLoadingSpinner from '@/components/full-screen-loading-spinner';
import * as Constants from '@/constants';

export default {
  name: 'ActionIcons',
  props: ['submission', 'fromDashboard', 'marginZero'],
  components: {
    FullScreenLoadingSpinner
  },
  computed: {
    isMobile() {
      return this.$mq === 'mobile';
    }
  },
  data() {
    return {
      showLoading: false
    };
  },
  methods: {
    editForm() {
      this.$router.push(`/edit/${this.submission.sessionId}`);
    },
    copyForm() {
      this.$router.push(`/copy/${this.submission.sessionId}`);
    },
    removeFromLocalStorage(id) {
      // get the submission array from local storage, parse as JSON
      const saved = JSON.parse(localStorage.getItem('submission-array')) || [];
      let filtered;
      // make sure the array isnt empty
      if (saved.length) {
        filtered = saved.filter((s) => {
          return s.sessionId !== id;
        });
        // add the filtered array back to localstorage
        localStorage.setItem('submission-array', JSON.stringify(filtered));
      }
    },
    deleteForm(event) {
      // prevent propagation of button click event to underlying container click
      event.stopPropagation();
      const id = this.submission.sessionId;
      Swal.fire({
        text: 'Are you sure you want to delete this Service Log?',
        confirmButtonText: 'Delete',
        showCancelButton: true,
        customClass: {
          popup: 'popup-class',
          content: 'content-class',
          confirmButton: 'confirm-button-class delete'
        }
      }).then((response) => {
        // okay was clicked, delete the log
        if (response && response.value) {
          this.showLoading = true;
          api.delete(Constants.DELETE_PT_SESSION_URL(id))
            .then(() => {
              this.removeFromLocalStorage(id);
              this.$emit('service-log:deleted');
              const Toast = Swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                onOpen: (toast) => {
                  toast.addEventListener('mouseenter', Swal.stopTimer);
                  toast.addEventListener('mouseleave', Swal.resumeTimer);
                }
              });
              Toast.fire({
                icon: 'success',
                title: 'Service Log has been successfully deleted.',
                customClass: {
                  popup: 'popup-class'
                }
              });
            })
            .catch((error) => {
              this.errorMsg = error.message;
            })
            .finally(() => {
              this.showLoading = false;
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
  .action-button-container {
    min-width: 116px;
  }
  .action-button {
    margin: 0 0 0 8px;
    height: 36px;
    width: 36px;
    .v-icon {
      font-size: 18px;
    }

    &.mobile {
      margin: 0 16px;
      &.margin-zero {
        margin: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/action-icons.vue